export const title = {
    'en': 'Text Sentiment',
    'zh-tw': '文字情緒辨識'
};

export const inputText = {
    'en': 'Enter text sentiment[defaultText]',
    'zh-tw': '輸入文字情緒[defaultText]'
};

export const defaultText = {
    'en': 'Please enter text',
    'zh-tw': '請輸入文字'
};

export const startTextSentiment = {
    'en': 'Start Text Emotion Recognition',
    'zh-tw': '開始文字情緒辨識'
};

export const confidence = {
    'en': 'Text Emotion Confidence',
    'zh-tw': '文字情緒置信度'
};